<template>
    <div class="contact-wrapper">
        <div class="rqstBg">
            <a href="https://www.yurtlarburada.com/uniyurt-kiz-ve-erkek-ogrenci-yurtlari-s-2842/" class="requestBgLink" target="_blank">Fotoğraf: Üniyurt Kız ve Erkek Öğrenci Yurtları</a>
        </div>
        <Modal2 :active="showSuccessMessage" @onModalClose="closeModalSuccess">
            <div slot="content">
                <div class="login-box mywidth" style="margin: 0 auto">
                    <h2 class="login-box__title">TALEBİNİZ GÖNDERİLDİ!</h2>
                    <div class="or">
                        <p><span>İlginiz için Teşekkür Ederiz.</span></p>
                        <p ><span>İlgili yurtlar en yakın zamanda sizinle iletişime geçecek.</span></p>                        
                    </div>
                </div>
            </div>
        </Modal2>
<Modal2 :active="showErrorMessage" @onModalClose="closeModalError">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title2" >TALEBİNİZ GÖNDERİLEMEDİ!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">Malesef şu anda işlemeniz başarısız sonuçlandı!</span></p>
      <p ><span class= "mycolorBlue">Lütfen yurtlar ile doğrudan iletişime geçiniz.</span></p>
    </div>
     </div>
</div>
</Modal2>
        <div class="section contact-section">
            <div>
                <container>
                    <div class="contact-section_gen text-left col-xl-10 offset-xl-1">
                        <form id="myForm" v-on:submit.prevent="onSubmit">
                        <div class="login-box">
                            <h3 class="login-box__title"><span
                            class="color-light-green">Yurtlar Seni Arasın<br>Yurt Fiyatlarını Öğren</span></h3>
                            <v-input placeholder="Ad Soyad" v-model="name" v-on:keyup.native="saveForm"/>
                            <label for="password" v-if="emptyName" class="myValidationText">Bu kısım boş geçilemez!</label>
                            <v-input placeholder="Telefon No" v-model="phone" v-on:keyup.native="saveForm"/>
                            <label for="password" v-if="emptyPhone" class="myValidationText">Bu kısım boş geçilemez!</label>
                            <label for="phone" v-if="falsePhone" class="myValidationText">Telefon numarası 0 ile başlamalıdır!</label>
                            <label for="phone" v-if="shortPhone" class="myValidationText">Telefon numarası 11 hane olmalıdır!</label>
<!--                             <v-input placeholder="E-mail Adresi" v-model="email" />
                            <label for="password" v-if="emptyEmail" class="myValidationText">Bu kısım boş geçilemez!</label>
                            <label for="password" v-if="falseEmail" class="myValidationText">Geçersiz e-posta formatı!</label> -->
                            <!--             <v-input placeholder="Mesajın Konusu" v-model="subject"/>
                             <v-input placeholder="Mesajınız" class="textarea" v-model="message"/>
                             <label for="password" v-if="emptyMessage" class="myValidationText">Bu kısım boş geçilemez!</label> -->
                            <v-select v-if="university_name === 'Üniversite Seç' || university_name === null || university_name ===''" :options="universities" placeholder="Üniversite Seçiniz" @onselect="selectUniversity" />
                            <VueSelectTempUniversity v-else :options="universities" placeholder="Üniversite Seçiniz" @onselect="selectUniversity" />
                            <label for="password" v-if="emptyUniversity" class="myValidationText">Bu kısım boş geçilemez!</label>
                            <!-- <SelectBox2old :options="faculties" placeholder='Fakülte Seç' :title="faculty_name" @onselect="selectFaculty" /> -->
                            <!-- <VueSelect2 v-if="faculty_name === 'Fakülte Seç' && university_name !='Üniversite Seç'" :options="faculties" placeholder='Fakülte Seç' :title="faculty_name" @onselect="selectFaculty" /> -->
                            <VueSelectTempFaculty v-if="facultyEnabled" placeholder="Fakülte Seç" :options="faculties" @onselect="selectFaculty" />
                            <SelectBox2 v-if="!facultyEnabled" myplaceholder="Fakülte Seç" :options="faculties" :title="faculty_name" @onselect="selectFaculty" disabled/>
                            <label for="password" v-if="emptyFaculty" class="myValidationText">Bu kısım boş geçilemez!</label>
                            <!-- <VueSelectTempGender :options="genders" :title="gender_name" @onselect="selectGender"/> -->
                            <v-select v-if="!genderSelected" :options="genders" placeholder="Yurt Tipi Seç" @onselect="selectGender"></v-select>
                            <VueSelectTempGender v-if="genderSelected"
                                    placeholder="Yurt Tipi Seç" :options="genders" @onselect="selectGender"/>        
                            <label for="phone" v-if="emptyGender" class="myValidationText">Bu kısım boş geçilemez!</label>
                            <div class="check-wrapper smart-map">
                                <div class="check-wrapper__item">
                                    <label class="container2" style="width: 100%;">
                                        <div ref="mycheck" class="check">
                                            <input type="checkbox" v-model="checkedForm" style="width: auto;"><span class="checkmark"></span>
                                            <a href="/kullanici-sozlesmesi" class="" itemtype="https://schema.org/Thing" itemprop="item" target="_blank">
                                                <span class="name">Kullanıcı Sözleşmesi’ni okudum, kabul ediyorum.</span></a>
                                        </div>
                                    </label>
                                    <label for="password" v-if="emptyCheckForm" class="myValidationText">Kullanıcı Sözleşmesi'ni kabul etmeniz gerekiyor!!</label>
                                </div>
                            </div>
                            <!-- <label for="password" v-if="emptyFaculty" class="myValidationText">Bu kısım boş geçilemez!</label>              -->
                            <v-button class="green fw shadow-none login-box__submit" title="GÖNDER" v-if="messageEnabled" @click.native="sendMessage()" />
                            <v-button class="green fw shadow-none login-box__submit" title="GÖNDERİYOR" v-if="!messageEnabled"/>
                        </div>
</form>
                        <!--           <div class="contact-right">
            <div class="contact-right_gen">
              <div class="contact-right__item">
                <p class="contact-right__item-detail">
                  <img src="@/assets/img/printer.svg" class="contact-right__item-detail-img" alt="">destek@yurtlarburada.com
                </p>
                <p class="contact-right__item-detail">
                  <img src="@/assets/img/contact.svg" class="contact-right__item-detail-img" alt="">0541 212 98 78
                </p>
                <p class="contact-right__item-detail">
                  <img src="@/assets/img/address.svg" class="contact-right__item-detail-img" alt="">Sakarya Üniversitesi
                  Teknokent Esentepe Mah. Akademi Yolu Sok. B-Blok 112 54050 Serdivan, Sakarya
                </p>
              </div>
              <div class="contact-right__item">
                <SocialGroup/>
              </div>
            </div>
          </div> -->
                    </div>

                    <div class="clearfix"></div>
                    <div class="requestText text-center">
                      <div class="container">
                        <h3>Yurt Fiyatları Cebine Gelsin!</h3>
                        <p>Yurt fiyatlarını öğrenmek için tek tek yurtları arama, hiçbir ücret ödemeden yurtlar seni arasın! Kazandığın üniversiteyi seç, bölgedeki yurtlar imkanları ve güncel fiyatları ile ilgili sms veya telefon yoluyla sana bilgi versin.</p>
                      </div>
                    </div>
                </container>
            </div>
        </div>
    </div>
</template>
<script>
import Modal2 from '@/components/Modal2'
import SelectBox2 from '@/components/SelectBox2'
import VueSelectTempUniversity from '@/components/VueSelectTempUniversity'
import VueSelectTempFaculty from '@/components/VueSelectTempFaculty'
import VueSelectTempGender from '@/components/VueSelectTempGender'
import axios from 'axios'

export default {
  name: 'RequestPrice',
  components: {
    Modal2, SelectBox2, VueSelectTempUniversity, VueSelectTempFaculty, VueSelectTempGender
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be use
      title: 'Yurtlar Seni Arasın | Güncel Yurt Fiyatlarını Öğren',
      meta: [
        { vmid: 'description', name: 'description', content: 'Yurt fiyatlarını öğrenmek için tek tek yurtları arama, yurtlar seni arasın! Kazandığın üniversiteyi seç, bölgedeki yurtlar ücretsiz olarak sms ve telefon yoluyla seni bilgilendirsin.' },
        { vmid: 'keywords', name: 'keywords', content: 'yurt fiyatları, öğrenci yurdu fiyatları, yurt ücretleri, kız öğrenci yurdu, erkek öğrenci yurdu, özel öğrenci yurtları, güncel yurt fiyatları' }
      ],
      link: [{
        rel: 'canonical',
        href: window.location.origin + '/yurt-fiyatlari/'
      }]
    }
  },
  data () {
    return {
      genders: [
        { id: 1, name: 'Erkek Öğrenci Yurdu' },
        { id: 2, name: 'Kız Öğrenci Yurdu' }
      ],
      errors: [],
      messageEnabled: true,
      emptyCheckForm: false,
      checkedForm: false,
      list: 'university',
      list_id: null,
      facultyEnabled: false,
      universities: null,
      faculties: null,
      university_name: 'Üniversite Seç',
      faculty_name: 'Fakülte Seç',
      university_id: '',
      faculty_id: '',
      faculty_id_temp: '',
      showSuccessMessage: false,
      showErrorMessage: false,
      name: null,
      phone: null,
      email: null,
      subject: '',
      message: '',
      emptyName: false,
      emptyMessage: false,
      emptyPhone: false,
      emptyEmail: false,
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      emptyUniversity: false,
      emptyFaculty: false,
      genderSelected: false,
      emptyGender: false,
      gender: null
    }
  },
  methods: {
    onSubmit () {
    },
    saveForm () {
      window.localStorage.setItem('username', this.name)
      window.localStorage.setItem('phone1', this.phone)
    },
    selectGender (opt) {
      this.gender = opt.id
      this.genderSelected = true
      window.localStorage.setItem('gender', opt.id)
    },
    validateEmail (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    getFormData () {
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyCheckForm = false
      this.emptyFaculty = false
      // this.emptyFaculty = false
      if (!window.localStorage.getItem('gender') || window.localStorage.getItem('gender') === '' || window.localStorage.getItem('gender') === 'null') {
      } else {
        this.gender = window.localStorage.getItem('gender')
        this.genderSelected = true
      }
      // repopulate faculty dropdown
      if (window.localStorage.getItem('university_id')) {
        this.university_id = window.localStorage.getItem('university_id')
        this.list_id = window.localStorage.getItem('university_id')
        this.list = 'university'
      }
      if (!window.localStorage.getItem('university_name') || window.localStorage.getItem('university_name') === '' || window.localStorage.getItem('university_name') === 'null' || window.localStorage.getItem('university_name') === 'undefined') {
        // if(this.messageForm.university_id) {

        this.university_name = 'Üniversite Seç'
      } else {
        this.university_name = window.localStorage.getItem('university_name')
        var self = this
        axios.get(`/selected/faculties/${this.university_id}`)
          .then(response => {
            self.faculties = response.data
          })
          .catch(e => {
            this.errors.push(e)
          })
        this.facultyEnabled = true
        if (!window.localStorage.getItem('faculty_id') || window.localStorage.getItem('faculty_id') === '' || window.localStorage.getItem('faculty_id') === 'null' || window.localStorage.getItem('faculty_id') === 'undefined') {
          this.faculty_name = 'Fakülte Seç'
        } else {
          this.faculty_name = window.localStorage.getItem('faculty_name')
          this.faculty_id = window.localStorage.getItem('faculty_id')
        }
      }
      if (window.localStorage.getItem('username') === 'null') {
        this.name = ''
      } else {
        this.name = window.localStorage.getItem('username')
      }
      if (!window.localStorage.getItem('mail') || window.localStorage.getItem('mail') === '' || window.localStorage.getItem('mail') === 'null') {
        this.email = ''
      } else {
        this.email = window.localStorage.getItem('mail')
      }
      if (window.localStorage.getItem('phone1') === 'null') {
        this.phone = ''
      } else {
        this.phone = window.localStorage.getItem('phone1')
      }
    },
    selectUniversity (opt) {
      this.facultyEnabled = true
      this.university_id = opt.id
      this.list_id = opt.id
      this.university_id = opt.id
      this.university_name = opt.name
      let self = this
      axios.get(`/selected/faculties/${opt.id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
      window.localStorage.setItem('university_name', opt.name)
      window.localStorage.setItem('university_id', opt.id)
      // this.saveForm()
    },
    selectFaculty (opt) {
      this.faculty_id = opt.id
      this.faculty_name = opt.name
      window.localStorage.setItem('faculty_name', opt.name)
      window.localStorage.setItem('faculty_id', opt.id)
    },
    setUniversityName (id, facultyId) {
      let self = this
      axios.get('/selected/universities')
        .then(response => {
          response.data.forEach((data) => {
            if (data.id === id) {
              window.localStorage.setItem('university_name', data.name)
              self.university_name = window.localStorage.getItem(data.name)
            }
          })
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getUniversities () {
      let self = this
      axios.get('/selected/universities')
        .then(response => {
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    closeModalSuccess () {
      this.showSuccessMessage = false
    },
    closeModalError () {
      this.showErrorMessage = false
    },
    sendMessage () {
      this.emptyName = false
      this.emptyMessage = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyUniversity = false
      this.emptyFaculty = false
      this.emptyCheckForm = false
      this.emptyGender = false
      if (!this.name || this.name === ' ') {
        this.emptyName = true
      }
      if (!this.phone) {
        this.emptyPhone = true
      }
      if (this.phone && !this.phone.startsWith('0')) {
        this.falsePhone = true
      }
      if (this.phone && !this.falsePhone && this.phone.length !== 11) {
        this.shortPhone = true
      }

      if (this.university_name === '' || this.university_name === 'Üniversite Seç') {
        this.emptyUniversity = true
      }

      if (this.faculty_name === '' || this.faculty_name === 'Fakülte Seç') {
        this.emptyFaculty = true
      }
      if (this.university_name !== '' || this.university_name !== 'Üniversite Seç') {
        this.list = 'university'
        this.list_id = this.university_id
        this.faculty_id_temp = 0
        if (this.faculty_name !== '' && this.faculty_name !== 'Fakülte Seç') {
          this.list = 'faculty'
          this.list_id = this.faculty_id
          this.faculty_id_temp = this.faculty_id
        }
      }
      if (!this.checkedForm) {
        this.emptyCheckForm = true
      }
      if (!this.genderSelected) {
        this.emptyGender = true
      }
      if (!this.emptyName && !this.emptyPhone && !this.shortPhone && !this.emptyUniversity && !this.emptyFaculty && !this.emptyCheckForm && !this.emptyGender) { // && !this.emptyEmail && !this.emptyMessage) {
        this.messageEnabled = false
        var self = this
        axios.post(`site/dorm/message/multiple`, {
          email: 'empty@gmail.com',
          name: this.name,
          phone: this.phone,
          university_id: this.university_id,
          faculty_id: this.faculty_id_temp,
          list: this.list,
          list_id: this.list_id,
          gender: this.gender
        })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              this.showSuccessMessage = true
              this.messageEnabled = true
              document.getElementById('myForm').reset()
            } else {
              this.showErrorMessage = true
              this.messageEnabled = true
            }
          })
          .catch(e => {
            self.showErrorMessage = true
            self.messageEnabled = true
            self.errors.push(e)
          })
      }
    }
  },
  created () {
    this.getUniversities()
    this.getFormData()
  }
}
</script>
<style lang="scss">
    @import "../assets/scss/components/contact";
    .mywidth {
        min-width: 400px;
    }
</style>
